import { render, staticRenderFns } from "./transaction.init.form.vue?vue&type=template&id=26b83ca8&scoped=true"
import script from "./transaction.init.form.vue?vue&type=script&lang=js"
export * from "./transaction.init.form.vue?vue&type=script&lang=js"
import style0 from "./transaction.init.form.vue?vue&type=style&index=0&id=26b83ca8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b83ca8",
  null
  
)

export default component.exports